import MarkStep from "@/pages/publicpages/agent/wizard/MarkStep.vue";
import ModalWizard from '@/pages/publicpages/agent/wizard/Index.vue';
import GroupedErrors from "@/vue/components/GroupedErrors.vue";

Vue.component('GroupedErrors', GroupedErrors);

new Vue({
    el: '#list-agents-page',
    name: 'ListAgentsPage',
    components: {
        MarkStep,
        ModalWizard,
    },
    data(){
        return {
            step: 5,
        }
    },
    mounted() {
        this.$refs.wizard.step = 1;
        let rawEl = this.$refs['raw-search-criteria'];
        if (rawEl) {
            let values = JSON.parse(rawEl.value);
            Object.assign(this.$refs.wizard.$data.form, values);
            rawEl.remove();
        }
    }
})

document.getElementById("copyLinkToClipboardDiv")?.addEventListener("click", () => {
    let copyTextarea = document.getElementById("copyLinkToClipboard");
    copyTextarea.focus();
    copyTextarea.select();

    try {
        let successful = document.execCommand('copy');
        let msg = successful ? 'successful' : 'unsuccessful';
        console.debug('Copying text command was ' + msg);
        toastSuccess('Link copiado')
    } catch (err) {
        console.error('Oops, unable to copy', err);
    }
});
